<template>
    <!-- tabindex="-1" @focusout="closeMenu" -->
    <div :id="id" style="z-index: 10000">
        <div class="menu-header">
            <div v-for="tab in filteredTabs" :key="tab.key"
                 v-tooltip="tab.label"
                 @click="selectedTabKey = tab.key"
                 class="tab-btn"
                 :class="{ 'selected': tab.key === selectedTabKey }">
                <i :class="tab.icon"></i>
            </div>
            <div v-if="withCloseBtn" @click="closeMenu" class="close-btn">
                <i class="fal fa-times"></i>
            </div>
        </div>
        <div class="menu-tab">
            <TabObjects
                v-if="selectedTabKey === APP_MAP_PARAM_OBJECT"
                :block="block"
                :searchString="objectSearchString"
                @search="v => {objectSearchString = v; selectedCategories = {}}"
                @select="onObjectFieldSelect"
                @selectCategory="selectCategory"
                :selectedCategories="selectedCategories"
                />
            <TabOperators
                v-else-if="selectedTabKey === APP_MAP_PARAM_OPERATOR"
                @select="onOperatorSelect"/>
            <TabFunctions
                v-else-if="selectedTabKey === APP_MAP_PARAM_FUNCTION"
                @select="onFunctionSelect"/>
        </div>

        <div v-if="!disabled && !objectRefOnly && withComplexExpressionBtn"
             @click="$emit('start-expression')"
             class="start-expression"
             v-tooltip="'Start complex expression'">
            <i class="fa fa-sigma"></i>
        </div>
    </div>
</template>

<script>
import {
    APP_MAP_PARAM_FUNCTION,
    APP_MAP_PARAM_OBJECT,
    APP_MAP_PARAM_OPERATOR,
    moduleMappableParamMenuTabs,
    moduleMappableParamMenuTabsList
} from './app-module-mappable-param-menu'
import TabOperators from './TabOperators'
import TabFunctions from './TabFunctions'
import TabObjects from './TabObjects'
import Vue from 'vue'

export default {
    name: 'AppModuleMappableParameterMenu',
    components: {TabObjects, TabFunctions, TabOperators},
    props: {
        id: {
            type: String,
            required: true
        },
        block: {
            type: Object,
            required: false
        },
        objectRefOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        withComplexExpressionBtn: {
            type: Boolean,
            required: false,
            default: true
        },
        withCloseBtn: {
            type: Boolean,
            required: false,
            default: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            selectedTabKey: null,
            objectSearchString: '',
            selectedCategories: {},
            scrollTop: 0,

            APP_MAP_PARAM_OPERATOR,
            APP_MAP_PARAM_OBJECT,
            APP_MAP_PARAM_FUNCTION
        }
    },
    computed: {
        filteredTabs() {
            if (this.objectRefOnly) {
                return [moduleMappableParamMenuTabs.object]
            } else if (!this.block) {
                return [moduleMappableParamMenuTabs.operator, moduleMappableParamMenuTabs.function]
            }
            return moduleMappableParamMenuTabsList
        }
    },
    methods: {
        selectCategory(data) {
            Vue.set(this.selectedCategories, data.fieldPath, data.expand)
        },

        closeMenu() {
            this.$emit('close')
        },

        onObjectFieldSelect(data) {
            this.$emit('select', {
                type: APP_MAP_PARAM_OBJECT,
                data
            })
        },

        onOperatorSelect(operator) {
            this.$emit('select', {
                type: APP_MAP_PARAM_OPERATOR,
                data: operator
            })
        },

        onFunctionSelect(fun) {
            this.$emit('select', {
                type: APP_MAP_PARAM_FUNCTION,
                data: fun
            })
        }
    },

    // NOTE: self managed 'pass-mappable-param-menu-state' to achieve singleton menu (worked with vue-portal)
    // + preserve previous menu state
    created() {
        this.$bus.$on('pass-mappable-param-menu-state', data => {
            if (data.selectedTabKey) {
                this.selectedTabKey = data.selectedTabKey
            }
            if (data.objectSearchString) {
                this.objectSearchString = data.objectSearchString
            }
            if (data.selectedCategories) {
                this.selectedCategories = data.selectedCategories
            }
            if (data.scrollTop) {
                this.scrollTop = data.scrollTop
            }
        })

        if (!this.selectedTabKey &&
            this.filteredTabs &&
            this.filteredTabs[0]) {
            this.selectedTabKey = this.filteredTabs[0].key
        }
    },
    beforeDestroy() {
        this.$bus.$emit('pass-mappable-param-menu-state', {
            selectedTabKey: this.selectedTabKey,
            objectSearchString: this.objectSearchString,
            selectedCategories: this.selectedCategories,
            scrollTop: this.scrollTop
        })
    },
    updated() {
        if (this.scrollTop) {
            $('.menu-tab').scrollTop(this.scrollTop)
        }
        const vm = this
        $('.menu-tab').on('scroll', function() {
            vm.scrollTop = $(this).scrollTop()
        })
    }
}
</script>

<style scoped lang="scss">
    .menu-header {
        font-size: 18px;
        font-weight: 500;
        background: $color-purple-light;
        color: white;

        .tab-btn {
            display: inline-block;
            padding: 16px;

            &.selected, &:hover {
                cursor: pointer;
                background: $color-purple-soft;
                background: white;
                color: $color-purple-light;
            }
        }

        .close-btn {
            display: inline-block;
            float: right;
            padding: 16px 20px;

            &:hover {
                cursor: pointer;
            }
        }
    }

    .menu-tab {
        padding: 16px;
        overflow: auto;
        max-height: calc(100% - 60px);
    }

    .start-expression {
        position: absolute;
        bottom: 12px;
        right: 12px;
        line-height: 30px;
        height: 30px;
        width: 30px;
        vertical-align: middle;
        text-align: center;
        color: $color-purple-light;
        background: white;
        border: 1px dashed $color-gold;
        border-radius: 50%;
        font-size: 14px;

        &:hover {
            cursor: pointer;
        }
    }
</style>
